<template>
    <div class="max-w-[1200px] mx-auto w-full px-4 sm:px-6 lg:px-8">
        <slot></slot>
    </div>
</template>
